<template>
  <div class="printing-action">
    <naj-button
      square
      size="small"
      @click="print"
    >
      {{ local.common.print }}
    </naj-button>
  </div>
</template>

<script>
export default {
  methods: {
    print: () => {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-action {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 2px dashed #000;
}
@media print {
  .non-printable-content,
  .printing-action {
    display: none !important;
  }
  @page {
    margin: 8mm;
  }
}
</style>
